<template>
  <IconSelector iconText="flag" :class="mappedFlagColor"/>
</template>

<script>
import { mapGetters } from "vuex"
import IconSelector from "../combinedIcons/IconSelector.vue"

export default {
  name: "TimeTrackingCheckbox",
  components: {
    IconSelector,
  },
  props: {
    flagText: String,
  },
  data() {
    return {
      defaultColors: [
        {
          flagType: 'none',
        },
      ]
    }
  },
  computed: {
    ...mapGetters("todolist", {
      getFlagTypes: "getFlagTypes",
    }),
    mappedFlagColor() {
      switch (this.flagText) {
        case 'none':
          return 'text-gray-400'
        case 'minor':
          return 'text-green-600'
        case 'major':
          return 'text-amber-500'
        case 'critical':
          return 'text-orange-600'
        case 'blocker':
          return 'text-red-600'
        default:
          return 'text-gray-400'
      }
    }
  },
}
</script>
